module.exports = __webpack_public_path__ + "static/media/spinner_cover1.181330a1.svg";